import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useParams } from "react-router-dom";
import FAQSection from "../Components/FAQSection";

const PrivateYacht = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    guests: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Implementation for form submission
    console.log("Enquiry submitted:", formData);
  };
  const yachtFaqs = [
    {
      question: "What is included in a private yacht charter in Mumbai?",
      answer: "A standard charter includes the yacht rental, a certified crew (captain and deckhands), fuel, and safety equipment. Depending on your package, we also offer light refreshments, mineral water, and the option to customize decorations for special occasions."
    },
    {
      question: "Who is a private yacht charter suitable for?",
      answer: "Our private charters are ideal for couples seeking a romantic escape, families looking for a unique outing, or small groups of friends celebrating milestones. It's also a prestigious choice for corporate meetings or client hosting."
    },
    {
      question: "Can I book a yacht for a family outing or couple experience?",
      answer: "Absolutely. We specialize in curated experiences. For couples, we offer sunset sails with romantic setups. For families, we ensure a child-safe environment with spacious decks and comfortable indoor cabins."
    },
    {
      question: "Is a private yacht charter in Mumbai safe?",
      answer: "Yes, safety is our top priority. All our yachts are regularly inspected and maintained to international standards. We provide life jackets for all guests and our crew is trained in emergency protocols and first aid."
    },
    {
      question: "How do I choose the right yacht?",
      answer: "Choosing depends on your group size and the vibe you want. We offer everything from sleek speedboats for quick transfers to luxury motor yachts and classic sailing yachts for a more relaxed pace. Our experts can recommend the best fit based on your requirements."
    }
  ];

  useEffect(() => {
    // Update Document Meta for SEO
    document.title = "Private Yacht Charter Mumbai | Luxury Private Yacht Rental | Indiaboats";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Book a private yacht charter in Mumbai with Indiaboats for couples, families and small groups. Enjoy a premium, private and memorable experience on the water.");
    }

    // Add Schema Markup
    const schemaData = [
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Private Yacht Charter in Mumbai",
        "description": "Premium private yacht rentals in Mumbai for couples, families, and small groups.",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Indiaboats"
        },
        "areaServed": {
          "@type": "City",
          "name": "Mumbai"
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://indiaboats.com/"
        },{
          "@type": "ListItem",
          "position": 2,
          "name": "Private Yacht Charter Mumbai"
        }]
      }
    ];

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
    <Header/>
      
       <div className="ib-page-wrapper">

         <section className="ib-hero-section">
        <div className="ib-hero-background">
          <img 
            src="private-yacht-charter-mumbai.jpg" 
            alt="Private yacht charter in Mumbai for couples and families" 
            className="ib-hero-image"
            onError={(e) => {
              e.target.src = 'assets/img/img2.png';
            }}
          />
          <div className="ib-hero-overlay"></div>
        </div>

        <div className="ib-hero-content">
          <h1 className="ib-hero-title">
            Private Yacht Charter in Mumbai
          </h1>

          <p className="ib-hero-description">
            Experience the ultimate luxury on the Arabian Sea with our premium private rentals.<br />
            Perfect for romantic escapes, family outings, and intimate gatherings.
          </p>

          <div className="ib-cta-group">
            <a href="#enquire" className="th-btn style3 th-icon">
              Enquire Now
            </a>

            <a href="https://wa.me/91XXXXXXXXXX" className="ib-btn-whatsapp">
              <svg className="ib-whatsapp-icon" viewBox="0 0 24 24">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.417-.003 6.557-5.338 11.892-11.893 11.892-1.997-.001-3.951-.5-5.688-1.448l-6.305 1.652zm6.599-3.835l.474.282c1.143.681 2.425 1.04 3.743 1.041l.022.001c5.676 0 10.293-4.617 10.293-10.293 0-2.751-1.073-5.337-3.024-7.287-1.948-1.95-4.533-3.025-7.289-3.025-5.676 0-10.292 4.617-10.292 10.293 0 1.908.525 3.771 1.516 5.396l.311.51-.975 3.56 3.65-.958z"/>
              </svg>
              WhatsApp Us
            </a>
          </div>

          <div className="ib-trust-container">
            <p className="ib-trust-text">
              Premium Fleet | Safety First | Trained Crew | Mumbai & Goa | Private & Corporate Experiences
            </p>
          </div>
        </div>
      </section>
    </div>

     <div className="ib-page-wrapper">

     <section className="ib-centerpiece-section">
        <div className="ib-centerpiece-container">
          <header className="ib-centerpiece-header">
            <h2 className="ib-centerpiece-title">Why choose <span>us?</span></h2>
            <p className="ib-centerpiece-subtitle">
              Setting the standard for luxury seafaring in Mumbai with an unwavering commitment to excellence, safety, and personalized hospitality.
            </p>
          </header>

          <div className="ib-centerpiece-main">
            {/* Left Features */}
            <div className="ib-feature-col">
              <div className="ib-feature-item ib-align-right">
                <div className="ib-feature-icon">
                  <svg width="36" height="36" fill="#113d48" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                </div>
                <h3 className="ib-feature-name">Premium Fleet</h3>
                <p className="ib-feature-desc">Access Mumbai's most exclusive collection of luxury yachts, maintained to the highest international standards.</p>
              </div>

              <div className="ib-feature-item ib-align-right">
                <div className="ib-feature-icon">
                  <svg width="36" height="36" fill="#113d48" viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>
                </div>
                <h3 className="ib-feature-name">Safety First</h3>
                <p className="ib-feature-desc">Your safety is non-negotiable. Every charter is equipped with certified gear and overseen by experienced crew.</p>
              </div>
            </div>

            {/* Center Image */}
            <div className="ib-image-frame">
              <img 
                src="private-yacht-charter-mumbai.jpg" 
                alt="Luxury Yacht Interiors" 
                className="ib-center-img"
                onError={(e) => { e.target.src = 'assets/img/img1.png'; }}
              />
            </div>

            {/* Right Features */}
            <div className="ib-feature-col">
              <div className="ib-feature-item">
                <div className="ib-feature-icon">
                  <svg width="36" height="36" fill="#113d48" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                </div>
                <h3 className="ib-feature-name">Expert Crew</h3>
                <p className="ib-feature-desc">Our hospitality-trained staff ensures a seamless, private, and prestigious service throughout your journey.</p>
              </div>

              <div className="ib-feature-item">
                <div className="ib-feature-icon">
                  <svg width="36" height="36" fill="#113d48" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                </div>
                <h3 className="ib-feature-name">Prime Locations</h3>
                <p className="ib-feature-desc">Strategic boarding points across Mumbai for convenient access to the most scenic nautical routes.</p>
              </div>
            </div>
          </div>

          <div className="ib-centerpiece-cta">
            <a href="#enquire" className="th-btn style3 th-icon">Enquire Now</a>
          </div>
        </div>
      </section>
    </div>

     <div className="ib-page-wrapper">

    <section className="ib-audience-section">
        <div className="ib-audience-container">
          <header className="ib-audience-header">
            <span className="ib-audience-label">Curated Experiences</span>
            <h2 className="ib-audience-title">Who This Experience Is Perfect For</h2>
          </header>

          <div className="ib-audience-grid">
            {/* Category 1: Couples */}
            <div className="ib-audience-card">
              <img 
                src="/assets/img/img3.png" 
                alt="Romantic couple on a private yacht" 
                className="ib-audience-bg"
              />
              <div className="ib-audience-overlay">
                <span className="ib-audience-card-tag">Intimate & Romantic</span>
                <h3 className="ib-audience-card-title">Couples & Proposers</h3>
                <p className="ib-audience-card-desc">
                  Create a breathtaking romantic milestone. Perfect for sunset proposals, anniversary celebrations, or a private escape from the city hustle.
                </p>
              </div>
            </div>

            {/* Category 2: Families */}
            <div className="ib-audience-card">
              <img 
                src="assets/img/img4.png" 
                alt="Family enjoying time on a yacht" 
                className="ib-audience-bg"
              />
              <div className="ib-audience-overlay">
                <span className="ib-audience-card-tag">Safe & Memorable</span>
                <h3 className="ib-audience-card-title">Families & Small Groups</h3>
                <p className="ib-audience-card-desc">
                  Bond over the waves in a safe, private environment. Our yachts offer the perfect setting for family brunches and intimate gatherings.
                </p>
              </div>
            </div>

            {/* Category 3: Celebration */}
            <div className="ib-audience-card">
              <img 
                src="assets/img/img1.png" 
                alt="Luxury yacht party" 
                className="ib-audience-bg"
              />
              <div className="ib-audience-overlay">
                <span className="ib-audience-card-tag">Premium & Elite</span>
                <h3 className="ib-audience-card-title">Private Celebrations</h3>
                <p className="ib-audience-card-desc">
                  Host your birthdays or private milestones in style. A prestigious venue that guarantees exclusivity and a high-end atmosphere.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

     <div className="ib-page-wrapper">

      <section className="ib-expect-section">
        <div className="ib-expect-container">
          <header className="ib-expect-header">
            <span className="ib-expect-label">The Journey</span>
            <h2 className="ib-expect-title">What to Expect on Your <br/>Private Yacht Charter</h2>
          </header>

          <div className="ib-step-grid">
            {/* Step 1 */}
            <div className="ib-step-row">
              <div className="ib-step-content">
                <div className="ib-step-number">01</div>
                <h3 className="ib-step-headline">VIP Boarding Experience</h3>
                <p className="ib-step-text">
                  Your journey begins at Mumbai's iconic Gateway of India or a private jetty. Our crew welcomes you with professional warmth, ensuring a seamless transition from the city buzz to the tranquility of the sea.
                </p>
                <div className="ib-step-features">
                  <span className="ib-feature-tag">Priority Access</span>
                  <span className="ib-feature-tag">Meet & Greet</span>
                  <span className="ib-feature-tag">Private Transfers</span>
                </div>
              </div>
              <div className="ib-step-visual">
                <img 
                  src="yacht-boarding-mumbai.jpg" 
                  alt="Private yacht boarding experience Mumbai" 
                  className="ib-step-img"
                  onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&q=80&w=1000'; }}
                />
              </div>
            </div>

            {/* Step 2 */}
            <div className="ib-step-row">
              <div className="ib-step-content">
                <div className="ib-step-number">02</div>
                <h3 className="ib-step-headline">Bespoke On-Board Luxury</h3>
                <p className="ib-step-text">
                  Once on board, the yacht is entirely yours. Enjoy air-conditioned cabins, spacious decks, and premium amenities. Whether it's a romantic setup or a celebratory vibe, the atmosphere is tailored to your occasion.
                </p>
                <div className="ib-step-features">
                  <span className="ib-feature-tag">Luxury Interiors</span>
                  <span className="ib-feature-tag">Sound System</span>
                  <span className="ib-feature-tag">Refreshments</span>
                </div>
              </div>
              <div className="ib-step-visual">
                <img 
                  src="luxury-yacht-interiors.jpg" 
                  alt="Luxury yacht interiors and amenities" 
                  className="ib-step-img"
                  onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1605281317010-fe5ffe798166?auto=format&fit=crop&q=80&w=1000'; }}
                />
              </div>
            </div>

            {/* Step 3 */}
            <div className="ib-step-row">
              <div className="ib-step-content">
                <div className="ib-step-number">03</div>
                <h3 className="ib-step-headline">Panoramic Coastal Views</h3>
                <p className="ib-step-text">
                  Sail past the Taj Mahal Palace, Mumbai's historic lighthouses, and the modern skyline. Experience the magic of the golden hour as the sun sets over the Arabian Sea, creating a backdrop unlike any other.
                </p>
                <div className="ib-step-features">
                  <span className="ib-feature-tag">Skyline Views</span>
                  <span className="ib-feature-tag">Sunset Magic</span>
                  <span className="ib-feature-tag">Photo Ops</span>
                </div>
              </div>
              <div className="ib-step-visual">
                <img 
                  src="mumbai-skyline-yacht.jpg" 
                  alt="Mumbai skyline views from a private yacht" 
                  className="ib-step-img"
                  onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1570710891163-6d3b5c47248b?auto=format&fit=crop&q=80&w=1000'; }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

     <div className="ib-page-wrapper">
      
      <section className="ib-gallery-section">
        <div className="ib-gallery-container">
          <header className="ib-gallery-header">
            <span className="ib-gallery-label">Gallery</span>
            <h2 className="ib-gallery-title">The Indiaboats Experience</h2>
          </header>

          <div className="ib-gallery-grid">
            {/* 1. Large Main Feature (2x2) */}
            <div className="ib-gallery-item ib-span-2-2">
              <img 
                src="yacht-deck-view-mumbai.jpg" 
                alt="Luxury yacht deck view at sunset" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'assets/img/img1.png'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Panoramic Sun Deck</span>
              </div>
            </div>

            {/* 2. Portrait Feature (1x2) */}
            <div className="ib-gallery-item ib-span-1-2">
              <img 
                src="yacht-interior-luxury.jpg" 
                alt="Luxury cabin interiors" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'assets/img/img3.png'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Plush Master Cabin</span>
              </div>
            </div>

            {/* 3. Small Square (1x1) */}
            <div className="ib-gallery-item">
              <img 
                src="mumbai-skyline-yacht-view.jpg" 
                alt="Skyline view from sea" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'assets/img/img4.png'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Skyline Horizons</span>
              </div>
            </div>

            {/* 4. Small Square (1x1) */}
            <div className="ib-gallery-item">
              <img 
                src="yacht-refreshments-service.jpg" 
                alt="Champagne and snacks on yacht" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1516939884455-1445c8652f83?auto=format&fit=crop&q=80&w=800'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Gourmet Service</span>
              </div>
            </div>

            {/* 5. Small Square (1x1) */}
            <div className="ib-gallery-item">
              <img 
                src="yacht-party-celebration.jpg" 
                alt="Private party on yacht" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=800'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Private Events</span>
              </div>
            </div>

            {/* 6. Landscape Bottom (2x1) */}
            <div className="ib-gallery-item ib-span-2-1">
              <img 
                src="sailing-yacht-mumbai.jpg" 
                alt="Classic sailing yacht at Gateway of India" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'assets/img/img4.png'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Classic Sailing Fleet</span>
              </div>
            </div>

            {/* 7. Small Square (1x1) */}
            <div className="ib-gallery-item">
              <img 
                src="yacht-night-view.jpg" 
                alt="Yacht view at night" 
                className="ib-gallery-img"
                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1605281317010-fe5ffe798166?auto=format&fit=crop&q=80&w=800'; }}
              />
              <div className="ib-gallery-overlay">
                <span className="ib-gallery-caption">Evening Voyages</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

     <div className="ib-main-content">
     
      <FAQSection 
        pageKey="party-yacht-mumbai-goa"
        title="FAQs About Private Yacht Charter" 
        faqData={yachtFaqs} 
      />
    </div>

     <div className="iyc-enquiry-wrapper">

       <section className="iyc-enquiry-section" id="enquire">
        <div className="iyc-enquiry-container">
          {/* Info Column */}
          <div className="iyc-enquiry-info">
            <span className="iyc-enquiry-label">Book Your Journey</span>
            <h2 className="iyc-enquiry-title">Ready to Sail <br/>with Indiaboats?</h2>
            <p className="iyc-enquiry-text">
              Our concierge team is standing by to curate your perfect nautical experience. Whether it's a private celebration or a quiet sunset sail, we'll handle every detail.
            </p>
            
            <div className="iyc-contact-methods">
              <a href="https://wa.me/911234567890" className="iyc-contact-card">
                <div className="iyc-whatsapp-icon">
                  <svg width="32" height="32" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
                </div>
                <div>
                  <div style={{fontWeight: 700}}>WhatsApp Us</div>
                  <div style={{fontSize: '0.9rem', opacity: 0.7}}>Quick response: +91 98765 43210</div>
                </div>
              </a>
              <div className="iyc-contact-card">
                {/* SVG Stroke updated to a lighter teal to match the brand palette */}
                <div style={{color: '#34d399'}}>
                  <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                </div>
                <div>
                  <div style={{fontWeight: 700}}>Call Concierge</div>
                  <div style={{fontSize: '0.9rem', opacity: 0.7}}>Mon-Sun, 9:00 AM - 9:00 PM</div>
                </div>
              </div>
            </div>
          </div>

          {/* Form Column */}
          <div className="iyc-form-card">
            <form className="iyc-enquiry-form-grid" onSubmit={handleSubmit}>
              <div className="iyc-form-field">
                <label className="iyc-field-label">Full Name</label>
                <input type="text" className="iyc-field-input" placeholder="e.g. Rahul Sharma" required />
              </div>
              <div className="iyc-form-field">
                <label className="iyc-field-label">Phone Number</label>
                <input type="tel" className="iyc-field-input" placeholder="e.g. +91 98765 43210" required />
              </div>
              <div className="iyc-form-field">
                <label className="iyc-field-label">Preferred Date</label>
                <input type="date" className="iyc-field-input" required />
              </div>
              <div className="iyc-form-field">
                <label className="iyc-field-label">No. of Guests</label>
                <input type="number" className="iyc-field-input" placeholder="e.g. 4" min="1" required />
              </div>
              <div className="iyc-form-field iyc-field-full">
                <label className="iyc-field-label">Message (Optional)</label>
                <textarea 
                  className="iyc-field-input" 
                  rows="4" 
                  placeholder="Tell us about your occasion..."
                  style={{resize: 'none'}}
                ></textarea>
              </div>
              <button type="submit" className="iyc-submit-action">Send Enquiry</button>
            </form>
          </div>
        </div>
      </section>
    </div>

<Footer/>
    </>
  );
};

export default PrivateYacht;
